import { render, staticRenderFns } from "./InvoicesEditingSection.vue?vue&type=template&id=38072632"
import script from "./InvoicesEditingSection.vue?vue&type=script&lang=js"
export * from "./InvoicesEditingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports